<template>
  <main id="main-content">
    <div class="body-content sessions-container">
      <!---inicio page--->
      <div class="page-controls">
        <div class="page-controls__control-row">
          <div class="page-controls__filter">
            <div
              class="dropdown-filter select-wrapper"
              v-bind:class="{
                'dropdown-filter--range-active':
                  selected_filter === $t('reviews.interval'),
              }"
            >
              <button
                class="button secondary disabled"
                @click="resetNameValue()"
                v-bind:class="{ 'd-none': evalIfDisplayTextFilterButton }"
              >
                <b-icon-x-circle />
                <spam>{{ filter_name }}</spam>
              </button>
              <div
                class="page-controls__search reviews-search ng-pristine ng-untouched ng-valid ng-isolate-scope ng-empty"
                v-bind:class="{ 'page-controls__search--opened': search_show }"
              >
                <div class="dropdown-search">
                  <button
                    class="dropdown-search__toggle icon-button align-right"
                    id="tooltip-target-search"
                    v-bind:class="{ 'd-none': search_show }"
                    @click="showSearch()"
                  >
                    <i
                      class="isax isax-search-normal-1"
                      style="font-size: 20px"
                    />
                  </button>
                  <b-tooltip target="tooltip-target-search" triggers="hover">
                    {{ $t("recordings.searchrecordings") }}
                  </b-tooltip>
                  <div
                    class="dropdown-search__dropdown"
                    v-bind:class="{ 'd-none': !search_show }"
                  >
                    <div class="dropdown-search__field">
                      <i
                        class="dropdown-search__icon isax isax-search-normal"
                        style="font-size: 20px"
                      />
                      <input
                        class="dropdown-search__input ng-pristine ng-valid ng-empty ng-touched"
                        type="text"
                        v-bind:placeholder="$t('reviews.searchbyname')"
                        v-model="filter_name"
                        @input="initReviews()"
                      />
                    </div>
                    <button
                      class="button clear short dropdown-search__control reviews-search__close ng-scope"
                      type="button"
                      @click="hideSearch()"
                    >
                      <span>{{ $t("buttons.close") }}</span>
                      <b-icon-x-circle class="reviews-search__close-icon" />

                    </button>
                  </div>
                </div>
              </div>
              <div class="icon-funnel">
                <i
                  class="icon isax isax-filter"
                  style="height: 20px; width: 20px; font-size: 20px"
                ></i>
              </div>

              <span class="dropdown-filter__select-label">{{
                $t("reviews.filterby")
              }}</span>
              <b-dropdown
                id="dropdown-right"
                right
                :text="selected_filter"
                variant=" dropdown-filter__select button button-select dropdown"
              >
                <b-dropdown-item @click="recentReviews()"
                  >{{ $t("reviews.recent") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="selected_filter = $t('reviews.interval')"
                  >{{ $t("reviews.interval") }}
                </b-dropdown-item>
              </b-dropdown>
              <form
                class="date-range ng-valid ng-valid-date ng-valid-required ng-dirty ng-valid-parse ng-valid-before-start"
                v-if="selected_filter === $t('reviews.interval')"
              >
                <div class="picker-input date">
                  <div class="dateFromLabel"><span>Fecha Desde:</span></div>
                  <b-form-datepicker

                    label-help="Usa las flechas del teclado para navegar entre fechas"
                    label-no-date-selected="-"
                    id="start-date"
                    type="text"
                    v-model="filter_start_date"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                    locale="es"
                    @input="initReviews()"
                    boundary="viewport"
                    :offset="4"
                  >
                    <template #button-content>
                      <i
                          style="font-size: 16px"
                          class="isax isax-calendar-tick"
                          aria-hidden="true"
                      ></i>
                    </template>
                  </b-form-datepicker>
                </div>
                <div class="picker-input date">
                  <div class="dateToLabel"><span>Fecha Hasta:</span></div>
                  <b-form-datepicker
                    label-help="Usa las flechas del teclado para navegar entre fechas"
                    label-no-date-selected="-"
                    id="end-date"
                    type="text"
                    v-model="filter_end_date"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                    locale="es"
                    @input="initReviews()"
                  >
                    <template #button-content>
                      <i
                          style="font-size: 16px"
                          class="isax isax-calendar-tick"
                          aria-hidden="true"
                      ></i>
                    </template>
                  </b-form-datepicker>
                </div>
              </form>
            </div>
          </div>
          <div class="page-controls__action-row" v-if="userStore.isAdmin">
            <button
              class="page-controls__primary-action button secondary short"
              v-b-toggle.sidebar="'sidebar-new'"
              @click="callInitReviewInChild()"
            >
              <span>{{ $t("reviews.create") }}</span>
            </button>
          </div>
        </div>
      </div>
      <div class="full-width-content--small">
        <div class="head_pagination_container mt-2">
          <div>
            <b-form-select
              v-on:change="resetPagination"
              plain
              class="limit-selector custom-select-icon"
              v-model="reviews_pagination.limit"
              :options="reviews_pagination_options"
            ></b-form-select>
          </div>
          <div>
            <span class="dropdown-filter__select-label"
              >{{ $t("reviews.messageitemsnum") }}{{ reviews_total }}</span
            >
          </div>
        </div>
        <div
          class="empty-list"
          v-if="!loading && (!reviews || reviews.length === 0)"
        >
          <h7 class="text-center" v-if="!userStore.isAdmin"
            >{{ $t("reviews.no_review") }}
          </h7>
          <h7 class="text-center" v-if="userStore.isAdmin"
            >{{ $t("reviews.no_review_admin") }}
          </h7>
        </div>
        <ul class="item-list session-list" v-show="!loading">
          <li v-for="review in reviews" v-bind:key="review.id">
            <reviewItem
              @confirmDelete="confirmDelete"
              @initReviews="initReviews"
              @deleteSelectChild="deleteSelectChild"
              :adminRole="userStore.isAdmin"
              :listToDelete="listToDelete"
              :review="review"
              :groups="groupStore.groups"
              :isChild="review.repeatFrom && review.reviewChildList.length != 0"
            ></reviewItem>
            <b-collapse :id="'child-items-list-' + review.id" visible>
              <ul class="item-list-child" v-show="!loading">
                <li
                  v-for="reviewchild in review.reviewChildList"
                  v-bind:key="reviewchild.id"
                >
                  <reviewItem
                    @confirmDelete="confirmDelete"
                    @initReviews="initReviews"
                    @selectChildToDelete="selectChildToDelete"
                    :adminRole="userStore.isAdmin"
                    :review="reviewchild"
                    :isChild="true"
                  ></reviewItem>
                </li>
              </ul>
            </b-collapse>
          </li>
        </ul>
      </div>
    </div>
    <footer
      v-if="reviews_pagination.limit < reviews_total"
      class="page-footer session-list-pagination"
    >
      <b-pagination
        v-model="reviews_pagination_current"
        :total-rows="reviews_total"
        :per-page="reviews_pagination.limit"
        align="center"
        aria-controls="report-content-table"
      ></b-pagination>
    </footer>
    <EditReviewSidebar
      ref="helloRef"
      @childInitReviews="initReviews"
      :groups="groupStore.groups"
    >
    </EditReviewSidebar>
  </main>
</template>
<script>
import i18n from "@/i18n";
import jwtMixin from "@/mixins/jwtMixin.js";
import utilitiesMixin from "@/mixins/utilitiesMixin";
import reviewItem from "@/components/Lti/CustomElements/reviewItem";
import EditReviewSidebar from "@/components/Lti/Modals/EditReviewSidebar.vue";
import ServiceReviews from "@/service/review.js";
import {
  BIconXCircle,
  BIconFilterRight,
  BIconFunnel,
  BIconSearch,
} from "bootstrap-vue";
import { ref } from "vue";
import useGroupState from "@/store/groupState.js";
import useUserState from "@/store/userState";
import useCourseState from "@/store/courseState";

const helloRef = ref(null);
export default {
  name: "RevisionesLti",
  components: {
    BIconSearch,
    //BIconFilterRight,
    //BIconXSquare,
    BIconFunnel,
    BIconXCircle,
    reviewItem,
    EditReviewSidebar,
  },
  mixins: [jwtMixin, utilitiesMixin],
  created() {
    this.loading = true;
    this.recentReviews();
  },
  data() {
    return {
      courseState: useCourseState(),
      userStore: useUserState(),
      groupStore: useGroupState(),
      helloRef,
      loading: false,
      search_show: false,
      filter_start_date: null,
      filter_end_date: null,
      filter_name: null,
      reviews: [],
      selected_filter: i18n.t("reviews.recent"),
      reviews_total: 0,
      reviews_pagination_current: 1,
      reviews_pagination: {
        limit: this.defaultPagination(),
        offset: 0,
      },
      reviews_pagination_options: this.paginationOptions(),
      listToDelete: [],
    };
  },
  computed: {
    evalIfDisplayTextFilterButton() {
      return !(
        this.filter_name != null &&
        this.filter_name !== "" &&
        !this.search_show
      );
    },
  },
  watch: {
    reviews_pagination_current: {
      handler: function () {
        // CMM: se establece la paginación acorde a la página activada
        this.reviews_pagination.offset =
          this.reviews_pagination.limit * (this.reviews_pagination_current - 1);
        this.initReviews();
      },
    },
  },
  methods: {
    callInitReviewInChild() {
      helloRef.value.initReview();
    },
    initReviews() {
      this.reviews = [];
      this.listToDelete = [];
      let vueComponent = this;
      this.loading = true;
      let filterParams = new URLSearchParams();
      filterParams.append("limit", this.reviews_pagination.limit);
      filterParams.append("offset", this.reviews_pagination.offset);
      filterParams.append("lmsId", this.courseState.site);
      if (this.userStore.isAdmin) {
        //
      } else if (this.userStore.isTutor) {
        //
      } else if (this.userStore.userRole.includes("ROLE_TEACHER")) {
        filterParams.append("organizerId", this.userStore.id);
      } else if (this.userStore.userRole.includes("ROLE_STUDENT")) {
        filterParams.append("participantId", this.userStore.id);
      }
      if (this.filter_name) {
        filterParams.append("name", this.filter_name);
      }
      if (this.filter_start_date) {
        filterParams.append(
          "startDate",
          window
            .moment(this.filter_start_date)
            .startOf("day")
            .utc()
            .format("YYYY-MM-DD[T]HH:mm:ss[Z]")
        );
      }
      if (this.filter_end_date) {
        filterParams.append(
          "endDate",
          window
            .moment(this.filter_end_date)
            .endOf("day")
            .utc()
            .format("YYYY-MM-DD[T]HH:mm:ss[Z]")
        );
      }
      ServiceReviews.getReviews(filterParams)
        .then((response) => {
          this.reviews_total = response.data.size;
          response.data.results.forEach(function (review) {
            vueComponent.reviews.push(review);
          });
        })
        .finally((this.loading = false));
    },
    hideSearch() {
      this.search_show = false;
      this.waiting_filter_name = false;
    },
    showSearch() {
      this.search_show = true;
    },
    recentReviews() {
      this.filter_start_date = null;
      this.selected_filter = i18n.t("reviews.recent");
      this.filter_end_date = window
        .moment()
        .add(12, "months")
        .format("YYYY-MM-DD");
      this.initReviews();
      this.filter_end_date = null;
    },
    resetNameValue() {
      this.filter_name = null;
      this.initReviews();
    },
    resetPagination() {
      // CMM: Si no estaba en la página inicial se cambia a la primera. El cambio lanza la recarga del listado
      if (this.reviews_pagination_current !== 1) {
        this.reviews_pagination_current = 1;
      } else {
        this.initReviews();
      }
    },
    confirmDelete(review) {
      let auxReview = review;
      this.$bvModal
        .msgBoxConfirm(`${this.$t("reviews.deleteMsg")}`, {
          title: this.$t("reviews.deleteTitle"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "ok-header-button",
          cancelVariant: "cancel-header-button",
          okTitle: this.$t("buttons.continue"),
          cancelTitle: this.$t("buttons.noContinue"),
          footerClass: "d-flex justify-content-between p-2",
          headerClass: "header-modal-cancel",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.loading = true;
            ServiceReviews.deleteReview(auxReview.id)
              .then((response) => {
                if (response && response.status === 200) {
                  this.$noty.success(this.$t("reviews.success-delete"), {
                    timeout: 3000,
                    progressBar: true,
                  });
                  this.initReviews();
                }
              })
              .catch((err) => {
                this.$noty.error(err);
              })
              .finally((this.loading = false));
          }
        })
        .catch((err) => {
          this.$noty.error(err);
        });
    },
    selectChildToDelete(review) {
      let isToDelete = this.listToDelete.includes(review);
      if (isToDelete) {
        // Quitar si existe en la lista
        this.listToDelete = this.listToDelete.filter((item) => item != review);
      } else {
        // Agregar a la lista para eliminar
        this.listToDelete.push(review);
      }
    },
    deleteSelectChild(reviewId) {
      // FILTRAR SOLO LAS QUE CORRESPONDAN A EL PADRE
      let list = this.listToDelete.filter((rev) => rev.repeatFrom == reviewId);
      let confirmList = [];
      this.$bvModal
        .msgBoxConfirm(
          `${list.length} ${this.$t("reviews.deleteMultipleQuestion")}`,
          {
            title: this.$t("reviews.deleteMultipleTitle"),
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: this.$t("buttons.continue"),
            cancelTitle: this.$t("buttons.noContinue"),
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            list.forEach(async (rev) => {
              ServiceReviews.deleteReview(rev.id)
                .then((response) => {
                  if (response && response.status === 200) {
                    // para confirmar si se han eliminado todo.
                    confirmList.push(rev);
                  }
                })
                .then(() => {
                  setTimeout(() => {
                    if (confirmList.length == list.length) {
                      this.$noty.success(
                        this.$t("reviews.success-multipleDelete"),
                        {
                          timeout: 3000,
                          progressBar: true,
                        }
                      );
                      this.initReviews();
                    }
                  }, 200);
                })
                .catch((err) => {
                  this.$noty.error(err);
                });
            });
          }
        });
    },
  },
};
</script>
